import { Select } from '@folio/stripes/components';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useLocaleWeekdays } from '../../utils/WeekdayUtils';
import css from './WeekdayPicker.css';
export var WeekdayPicker = function (props) {
    var intl = useIntl();
    var localeWeekdays = useLocaleWeekdays(intl);
    var options = useMemo(function () {
        var opts = [
            {
                value: undefined,
                label: '',
            },
        ];
        localeWeekdays.forEach(function (weekday) {
            return opts.push({
                value: weekday.weekday,
                label: weekday.long,
            });
        });
        return opts;
    }, [localeWeekdays]);
    return (React.createElement("div", { className: css.wrapper },
        React.createElement(Select, { "aria-label": props.ariaLabel, required: true, fullWidth: true, marginBottom0: true, dataOptions: options, value: props.value, onChange: function (e) {
                if (props.onChange) {
                    var value = e.target.value;
                    props.onChange(value === '' ? undefined : value);
                }
            }, error: props.error })));
};
export default WeekdayPicker;
